import * as React from 'react'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import AllViewOptions from '../store/internal/collections/AllViewOptions'
import ViewOptions from '../store/internal/models/ViewOptions'
import viewOptionsReducer, {
  ViewOptionsDispatch,
  ViewOptionsState,
  initialViewOptionsState,
} from './reducers/viewOptions'

type Context = [ViewOptionsState, ViewOptionsDispatch]

const { context: ViewOptionsContext, hook: useViewOptions } = createContext<Context>()

const ViewOptionsProvider = ({ children }: React.PropsWithChildren<object>) => {
  const localStorageKey = LOCAL_STORAGE_KEYS.shiftManagementAllViewOptions
  const [localStorageValue] = useLocalStorage<ViewOptions[]>(localStorageKey)
  // We need this map to convert the localStorageValue to ViewOptions instances with the functions
  const viewOptions = localStorageValue?.map((options) => new ViewOptions(options)) || []
  const allViewOptions = new AllViewOptions(viewOptions)

  const memoizedReducer = useCallback(viewOptionsReducer, [])
  const [state, dispatch] = React.useReducer(
    memoizedReducer,
    initialViewOptionsState({ allViewOptions })
  )

  return (
    <ViewOptionsContext.Provider value={[state, dispatch]}>{children}</ViewOptionsContext.Provider>
  )
}

export { ViewOptionsProvider, useViewOptions }
